module.exports = __webpack_public_path__ + "img/pure_waste.98858007.jpg";